import { call, put, takeEvery } from 'redux-saga/effects';
import { dealerActionCreators, DealerActionKeys, FetchDealer, IDealerApiResonse } from '..';
import { addressActionCreators } from '../../address';
import { businessEntityActionCreators } from '../../businessEntity';
import { uiActionCreators } from '../../ui';
import * as api from '../dealerApi';

function* fetchDealerSaga(action: FetchDealer) {
  yield put(uiActionCreators.showFullPageLoading());
  const response: IDealerApiResonse = yield call(api.fetchDealer, action.payload);

  yield put(addressActionCreators.setAddresses(response.addresses));
  yield put(
    businessEntityActionCreators.addAddresses([
      {
        addressIds: response.addresses.map(x => x.addressId),
        businessEntityId: response.businessEntityId
      }
    ])
  );
  yield put(
    businessEntityActionCreators.addNames([{ businessEntityId: response.businessEntityId, name: response.name }])
  );
  yield put(
    businessEntityActionCreators.setCompetitors({
      beId: response.businessEntityId,
      competitorIds: response.competitorIds
    })
  );
  yield put(
    businessEntityActionCreators.setRankType({ beId: response.businessEntityId, rankTypeId: response.rankTypeId })
  );
  yield put(
    businessEntityActionCreators.setMarketSegments({
      beId: response.businessEntityId,
      marketSegmentIds: response.marketSegmentIds
    })
  );
  yield put(
    businessEntityActionCreators.setProductCategories({
      beId: response.businessEntityId,
      categoryIds: response.productCategoryIds
    })
  );
  yield put(uiActionCreators.hideFullPageLoading());
  yield put(dealerActionCreators.fetchDealerFulfilled(response));
}

export function* watchFetchDealer() {
  yield takeEvery(DealerActionKeys.FETCH_DEALER, fetchDealerSaga);
}
